import { AddItemToBasketRequest } from './AddItemToBasketRequest';

export interface ValidatedBasket {
  productID: number;
  quantity: number;
  optionValueIDs: string[];
  addedAtCheckout: boolean;
}

export const validatedBasketFromResponse = (
  responseData: any,
): ValidatedBasket => ({
  productID: responseData.product_id,
  quantity: responseData.quantity,
  optionValueIDs: responseData.option_value_ids ?? [],
  addedAtCheckout: responseData.added_at_checkout,
});

export const validatedBasketToAddItemRequest = (
  validatedBasket: ValidatedBasket,
): AddItemToBasketRequest => ({
  productID: validatedBasket.productID,
  quantity: validatedBasket.quantity,
  optionValueID: validatedBasket.optionValueIDs[0],
  addedAtCheckout: validatedBasket.addedAtCheckout,
});
